export default {
    state:{
        condomData: {}
    },
    getters: {
        getCondomData(state) {
          return state.condomData;
        },
      },
      mutations: {
        setCondomData(state, data) {
          state.condomData = data;
        },
      },
    
      actions: {
        changeCondomData(context, data) {
          context.commit("setCondomData", data);
        },
      },
}